import { DocType } from "@/domain/shared";

export const convertToDigitStr = (str: number | string | undefined) => {
  if (!str) return ''
  const num = parseFloat(str.toString());
  return isNaN(num) ? '' : num.toLocaleString('es-AR');
}

export const formatDocNumber = (str: string, docType: DocType = DocType.DNI) => {
  if (!str) return ''
  if (docType === DocType.PAS || docType === DocType.PREC || docType === DocType.CDI) {
    return str
  }
  else if (docType !== DocType.CUIL && docType !== DocType.CUIT) {
    return convertToDigitStr(str.replaceAll(/[^0-9]/g, ''))
  }
  const value = str.replaceAll('-', '').replaceAll(/[^0-9]/g, '')
  if (value.length >= 11) {
    const dni = value.slice(2, value.length - 1)
    return value.slice(0, 2) + '-' + dni + '-' + value.slice(value.length - 1);
  }
  return value;
}